import { UploadInput } from '@framework/form';
import { t } from '@framework/i18n';
import { Tooltip } from 'antd';
import React from 'react';

export interface IUploadSignedModuleInputProps {
  disabled: boolean;
  submissionModuleId: string | null | undefined;
  setFile: (file: any) => void;
  loading: boolean;
}

export function getFileItem(id: string) {
  return {
    uid: id,
    name:
      id.split('/').pop() ??
      t('submission.documento-firmato', 'Documento Firmato'),
    status: 'done' as const,
  };
}

export function UploadSignedModuleInput(props: IUploadSignedModuleInputProps) {
  const { disabled, submissionModuleId, setFile, loading } = props;

  const tooltipTitle = disabled
    ? t(
        'submission.salva-modulo-per-caricare-file-firmato',
        'Salva il modulo per caricare il file firmato',
      )
    : undefined;

  return (
    <Tooltip title={tooltipTitle}>
      <UploadInput
        name={`upload-${submissionModuleId}`}
        title={t(
          'submission.seleziona-file-firmato',
          'Seleziona file firmato...',
        )}
        showUploadList={false}
        beforeUpload={file => {
          setFile(file);
          return false;
        }}
        buttonProps={{
          disabled: disabled,
          loading,
        }}
      />
    </Tooltip>
  );
}
